import {
  mediaHelper,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { IconName } from '../../app-kit/components/PropertyFeatures/types';
import { Feature } from './subcomponents/Feature/Feature';

const StyledFeature = styled.div`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
  margin: ${spacingHelper('extraSmall 0')};
`;

const FeatureContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  ${StyledFeature} {
    padding-right: ${spacingHelper('small')};
    flex-basis: 50%;
    ${mediaHelper('tabletMin')} {
      flex-basis: 33.33%;
    }
  }
`;

export interface FeatureItem {
  title: string;
  iconName: IconName;
  valueWithUnit?: string | null;
  hoverTitle?: string | null;
}

interface FeatureCollectionProps {
  features: FeatureItem[];
}

export const FeatureCollection: FunctionComponent<FeatureCollectionProps> = ({ features }) => {
  return (
    <FeatureContainer>
      {features.map(({ title, iconName, valueWithUnit }) => {
        return (
          <StyledFeature key={title}>
            <Feature key={title} iconName={iconName} title={title} valueWithUnit={valueWithUnit} />
          </StyledFeature>
        );
      })}
    </FeatureContainer>
  );
};
